// @flow

import React, { type Node, useCallback, useRef } from 'react';
import { InputText } from '../atom/input-text';
import { useInputMask } from '@tectonics/components/input-mask/use-input-mask';

export function InputBrazilianCpf(props: InputBrazilianCpfProps): Node {
  const { style, placeholder, value, onChange, ...rest } = props;

  const inputRef = useRef();
  const updateValueForMask = useInputMask(inputRef, MASK, value);

  const handleChange = useCallback((event: SyntheticInputEvent<InputText>) => {
    updateValueForMask();
    if (onChange) {
      onChange(event);
    }
  }, [onChange, updateValueForMask]);

  return (
    <InputText
      {...rest}
      type="tel"
      ref={inputRef}
      style={style}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
    />
  );
}

type InputBrazilianCpfProps = {
  style?: { [string]: string },
  placeholder?: string,
  value?: string,
  onChange?: (evt: SyntheticInputEvent<InputText>) => void,
};

const MASK = [
  /\d/, /\d/, /\d/, '.',
  /\d/, /\d/, /\d/, '.',
  /\d/, /\d/, /\d/, '-',
  /\d/, /\d/,
];
